class NotFoundError extends Error {
  constructor(message = "Resource Not Found") {
    super(message);
    this.statusCode = 404;
  }
}

export { NotFoundError };
